
export default {
  name: "blog",
  head() {
    return {
      title: `Blog - ${this.$store.getters.store.eshop.name}`,
      meta: [
        ...this.$hyperSeo.meta(),
        ...this.$hyperSeo.og(),
        {
          name: "app-version",
          content: this.$store.getters.store.cacheVersion,
        },
        this.$route.query.q?{
          hid: "robots",
          name: "robots",
          content:"noindex,follow",
        }:{
          hid: "robots",
          name: "robots",
          content:"index,follow",
        }
      ],
      script:[{
          hid: "ldBreadcrumbBlog",
          type: "application/ld+json",
          json: this.$hyperSeo.schemas(
            "breadcrumb",
            [{name:'Αρχική',url:'/'},{name:"Blog",url:"/blog"},{name:this.article.title}]
          ),
        }]
    };
  },
  watchQuery: true,
  async asyncData({ req, store, route, app, redirect }) {
    let host = "";
    if (process.server) {
      host = req.headers.host + route.fullPath;
    } else {
      host = location.host + route.fullPath;
    }
    if (route.params.q) {
      redirect(301, `/blog?q=${route.params.q}`);
    }
    let q = route.query.q || "";
    let a = await app.$hyperBlog.getArticles("q", q, 12, 1, true);
    let articles = a.articles;
    let pages = a.pages;
    let metadata = await app.$hyperBlog.getCategories();
    let unique = q || "__main";
    return { articles, metadata, pages, unique };
  },
  data() {
    return {
      articles: [],
      article: {},
      search: "",
      limit: 12,
      key: "q",
      total: 0,
      categories: [],
      metadata: {},
      pages: 1,
      unique: null,
    };
  },

  watch: {
    "$route.fullPath": function (v) {
      this.$nuxt.refresh();
    },
  },
  methods: {
    async getArticles(_) {
      this.articles = await this.$hyperBlog.getArticles(_.key, _.search, 16);
    },
  },
};
